<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    莲塘口岸站<br>
站点介绍<br>
莲塘口岸站位于深圳市罗湖区罗芳路与延方路交叉口，车站主体呈南北走向，南接新秀站，北接仙湖路站。 车站建筑设计简洁、明快、大方、易于识别，用现代简约的手法充分体现地域文化，区域文化，同时与周围的城市景观相协调，为地下四层车站，地下一层、地下二层为设备层，地下三层为站厅层，地下四层为站台层，站台形式为岛式站台。车站设置有4个出入口，临近莲塘口岸出境大厅，北端为广岭家园，西南侧为华清园及罗湖体育馆，东南侧为西岭花园、军事储备用地，东侧为兰亭国际名园、新世界四季御园住宅小区。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:00	23:33	2号线	2分35秒	5分45秒<br>
莲塘	06:29	00:07	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:07	23:32	2号线	4分钟	5分钟<br>
莲塘	06:29	00:07	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:07	00:22	2号线	4分钟	5分钟<br>
莲塘	06:29	01:07	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
A1出入口:<br>
罗沙路南侧（东）、西岭花园（东北门）、兰亭国际名园、新世界四季御园、莲塘口岸旅检大楼、罗湖区委党校、深圳广播电视大学罗湖分校、曦龙山庄<br><br>
A2出入口:<br>
兰亭国际名园<br><br>
A3出入口:<br>
新世界四季御园、莲塘口岸旅检大楼<br><br>
B出入口:<br>
罗沙路北侧（东）、广岭家园、萃峰阁<br><br>
C出入口:<br>
延芳路西侧（北）、深圳市公安局罗湖分局巡警大队、东湖公园、罗湖体育馆、罗湖行政服务大厅、罗湖体育公园、中建花园、华清园<br><br>
D出入口:<br>
罗沙路南侧（西）、延芳路西侧（南）、龙景花园芳庭苑<br><br>
公交换乘信息<br><br>
A3出入口:<br>
公交站名： 莲塘口岸①<br>
27、57、69、85、308、381、M314、M348、M364、M437、M526、高快巴士12(开往大梅沙闻檀道场站)<br><br>
A3出入口:<br>
公交站名： 莲塘口岸②<br>
111、113、202、218、220、387、B621、M103、M133、M182、M199、M207、M468、M468大站快车、M555<br><br>
B出入口:<br>
公交站名： 莲塘口岸①<br>
27、57、69、85、218、308、381、M314、M348、M364、M437、M526、高快巴士12(开往香梅北总站)<br><br>
B出入口:<br>
公交站名： 莲塘口岸②<br>
111、202、220、205、214、220、387、B621、M103、M133、M182、M199、M207、M468、M468大站快车、M555、高峰专线33原313（开往平湖辅城坳总站）<br><br>
C出入口:<br>
公交站名： 广岭<br>
113、308、M182、M348、M468、M437、M364<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>